import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

export const initialState = {
    basket: [],
    user: null,
};
export const getBasketTotal = (basket) => 
    basket?.reduce((amount, item) => item.price + amount, 0);

const  reducer = (state, action) => {
    console.log(action);
    switch(action.type) {
        case 'SET_USER':
            return {
                ...state,
                user: action.user,
            };

        case 'ADD_TO_BASKET':
            //LOGIC FOR ADDING ITEM TO BASKET
            return { 
                ...state,
                basket: [...state.basket, action.item]   
            };
        case 'REMOVE_FROM_BASKET':
            //LOGIC FOR REMOVING ITEM TO BASKET
            //clone the basket
            let newBasket = [...state.basket];
            //find the index of clicked product in the original basket then cut it out of the basket
            const index = state.basket.findIndex((basketItem) => basketItem.id ===action.id);
            if (index >=0) {
                newBasket.splice(index, 1);
                
            } else {
                console.warn(
                    `Cant remove product (id: ${action.id}) as its no`
                )
            }
            return { ...state, basket: newBasket };
        default:
            return state;
    }
}

export default reducer;